import { Card } from "../components";

export function CardContainer({ children }) {
  const github = "https://github.com/Aldothedev?tab=repositories"
  const resume = "https://drive.google.com/file/d/1ZM0PePK4xwB7NL0DvdK2FilAR9t3jbsf/view?usp=sharing";
  return (
    <>
      <Card>
        <Card.Box>
          <Card.Header>
            <Card.Icon href="https://github.com/Aldothedev/NetflixClone"
              src="./icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg
              href="https://vibrant-boyd-2074fc.netlify.app/"
              src="V3Portfolio/icons/link.svg"
            />
          </Card.Header>
          <Card.Title>netflix clone</Card.Title>
          <Card.Description>
            netflix clone created with react.js and firebase (sign up/auth). create dummy account to see full site. compatible with all devices. 
          </Card.Description>
          <Card.SubText>
            react.js, javascript (es6), jquary, firebase, fuse.js, responsive, html/css 
          </Card.SubText>
        </Card.Box>
        <Card.Box>
          <Card.Header>
            <Card.Icon 
              href="https://github.com/Aldothedev/SolarSystem-React"
              src="/icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg href="https://aldothedev.github.io/SolarSystem-React/" src="V3Portfolio/icons/link.svg" />
          </Card.Header>
          <Card.Title>solar system</Card.Title>
          <Card.Description>
            planet fact app for all planets in our solar system. 
          </Card.Description>
          <Card.SubText>react.js, javascript (es6), scss, figma, responsive, javascript</Card.SubText>
        </Card.Box>
        <Card.Box>
          <Card.Header>
            <Card.Icon href="https://github.com/Aldothedev/PayApi-Site"
              src="/icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg
              href="https://unruffled-colden-5c0403.netlify.app/"
              src="V3Portfolio/icons/link.svg"
            />
          </Card.Header>
          <Card.Title>api site</Card.Title>
          <Card.Description>
            marketing/api site with custom form validations. compatible with all devices.
          </Card.Description>
          <Card.SubText>
            react.js, javascript (es6), sass, jquary, html/css, responsive
          </Card.SubText>
        </Card.Box>
        {/* <Card.Box>
          <Card.Header>
            <Card.Icon 
              href="https://github.com/Aldothedev/ScreenSaver"
              src="/icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg
              href="https://aldothedev.github.io/ScreenSaver/"
              src="/icons/link.svg"
            />
          </Card.Header>
          <Card.Title>screen saver</Card.Title>
          <Card.Description>
            displays random quote pulled from api and shows current time, day of the week/year and week number, changes pic based on time.
          </Card.Description>
          <Card.SubText>javascript (es6), apis, scss, html</Card.SubText>
        </Card.Box> */}
        <Card.Box>
          <Card.Header>
            <Card.Icon 
              href="https://github.com/Aldothedev/Beats-Site"
              src="/icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg
              href="https://aldothedev.github.io/Beats-Site/"
              src="V3Portfolio/icons/link.svg"
            />
          </Card.Header>
          <Card.Title>beats site</Card.Title>
          <Card.Description>
            beats landing page with animations when scrolling. developed first with the "mobile first" methodology, compatible with all devices.
          </Card.Description>
          <Card.SubText>javascript (es6), figma, scss, html, css, responsive, animations</Card.SubText>
        </Card.Box>
        <Card.Box>
          <Card.Header>
            <Card.Icon 
              href="https://github.com/Aldothedev/GitHub-Profile-Search"
              src="/icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg
              href="https://aldothedev.github.io/GitHub-Profile-Search/"
              src="V3Portfolio/icons/link.svg"
            />
          </Card.Header>
          <Card.Title>github user search app</Card.Title>
          <Card.Description>
            bulit with github users api that pulls user profile info (repos, followers, social, etc...) includes a dark and light mode
          </Card.Description>
          <Card.SubText>react.js ,javascript (es6), apis, responsive</Card.SubText>
        </Card.Box>
        <Card.Box>
          <Card.Header>
            <Card.Icon 
              href="https://github.com/Aldothedev/Travel"
              src="/icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg href="https://aldothedev.github.io/Travel/" src="V3Portfolio/icons/link.svg" />
          </Card.Header>
          <Card.Title>travel website</Card.Title>
          <Card.Description>
            travel landing page with animations when scrolling. includes a dark and light mode and compatible with all devices.
          </Card.Description>
          <Card.SubText>javascript (es6), figma, tailwind, html, responsive, animations</Card.SubText>
        </Card.Box>
        {/* <Card.Box>
          <Card.Header>
            <Card.Icon 
              href="https://github.com/Aldothedev/GitHub-App"
              src="/icons/link.svg">{`</>`}
            </Card.Icon>
            <Card.LinkImg
              href="https://aldothedev.github.io/GitHub-App/"
              src="/icons/link.svg"
            />
          </Card.Header>
          <Card.Title>github user search app</Card.Title>
          <Card.Description>
            bulit with github users api that pulls user profile info including and includes a dark and light mode
          </Card.Description>
          <Card.SubText>javascript (es6), figma, scss, apis, responsive</Card.SubText>
        </Card.Box> */}
      </Card>
      <Card.ExternalLink href={github}>
        click to view more code projects on github
      </Card.ExternalLink>
      <Card.ExternalLink href={resume}>
        click to view my resume
      </Card.ExternalLink>
    </>
  );
}
